'use client';

import { Toaster } from '@/components/ui/sonner';
import dynamic from 'next/dynamic';

// Import Client dynamically (disable SSR)
const Client = dynamic(() => import('@/providers/client'), { ssr: false });

export default function ClientWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <Client>{children}</Client>
      <Toaster />
      {/* FirebaseAuthSync is mounted app-wide in providers/session-provider.tsx. */}
    </>
  );
}
